import { getRequest, postRequest } from "app/axiosClient";
import { getSignatureRecords, resetState } from "./CaptureSignatureSlice";
import {
  showLoader,
  hideLoader,
} from "../../CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import { updateAppointmentDetails } from "../Actions/ActionsAPI";
import OpenNotificationWithIcon from "common/utils/OpenNotificationWithIcon";
import { getAttachmentsList } from "features/Attachments/AttachmentsAPI";
export const updateSignatureAPI = (values) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Appointment/CaptureSignature`, values)
      .then((res) => {
        var request = {
          appointmentNbr: values.appointmentNbr,
          appointmentNoteId: values.NoteID,
        };
        dispatch(hideLoader());
        dispatch(updateAppointmentDetails(request));
        dispatch(getAttachmentsList(values.NoteID));
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "CaptureSignature.SuccessfullySavedSignature"
        );
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "CaptureSignature.UnableSaveSignature"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "CaptureSignature.UnableSaveSignature"
    );
  }
};
